const setPlayerConfig = (params) => {
    const { eVar184 } = params;

    return {
        defaults: {
            progress: {
                eVar13: '@MEDIA_PLAYER_CONTEXT@',
                eVar28: '@MEDIA_STREAM_ID@',
                eVar49: '@MEDIA_EMBED_HOST@',
                eVar80: '@TRACKING_ID@',
                eVar100: '@CONTENT_TYPE@',
                eVar170: 'false',
                eVar181: '@MEDIA_STREAM_TITLE@',
                eVar182: '@MEDIA_STREAM_ID@',
                eVar183: '@MEDIA_STREAM_ID@',
                eVar184: eVar184 || '@MEDIA_STREAM_TYPE@',
                eVar199: '@ADOBE_ID@',
                prop25: '@MEDIA_STREAM_ID@',
                prop26: '@MEDIA_PLAYER_VERSION@',
                prop27: '@MEDIA_PLAYER_CONTEXT@',
                prop28: '4.0',
                prop29: 'Progressive Download',
                prop30: '@MEDIA_STREAM_TITLE@',
                prop32: '@MEDIA_INDEX_NAME@',
                prop33: '@GAMEDAY_GAME_ID@',
                prop34: '@GAMEDAY_GAME_PK@',
                prop35: '@CURRENT_TIME_STAMP@',
                prop43: '@MEDIA_TOPIC_NAME@',
                prop49: '@MEDIA_EMBED_HOST@',
                prop54: '@MEDIA_SYSTEM_AUTO_PLAY@'
            }
        },
        containers: {
            '${playerId}': [
                {
                    wire: {
                        defaults: 'progress',
                        pEventKey: 'MEDIA_START'
                    },
                    events: 'event4,event2,event27',
                    eVar28: '@MEDIA_STREAM_ID@',
                    eVar170: 'false',
                    eVar183: '@MEDIA_STREAM_ID@',
                    eVar184: '@MEDIA_STREAM_TYPE@',
                    prop25: '@MEDIA_STREAM_ID@'
                },
                {
                    wire: {
                        defaults: 'progress',
                        pEventKey: 'PLAYBACK_PERCENT_25'
                    },
                    events: 'event67',
                    eVar170: 'false'
                },
                {
                    wire: {
                        defaults: 'progress',
                        pEventKey: 'PLAYBACK_PERCENT_50'
                    },
                    events: 'event68',
                    eVar170: 'false'
                },
                {
                    wire: {
                        defaults: 'progress',
                        pEventKey: 'PLAYBACK_PERCENT_75'
                    },
                    events: 'event69',
                    eVar170: 'false'
                },
                {
                    wire: {
                        pEventKey: 'MEDIA_COMPLETE'
                    },
                    events: 'event2,event28',
                    eVar13: '@MEDIA_PLAYER_CONTEXT@',
                    eVar28: '@MEDIA_STREAM_ID@',
                    eVar49: '@MEDIA_EMBED_HOST@',
                    eVar80: '@TRACKING_ID@',
                    eVar100: '@CONTENT_TYPE@',
                    eVar170: 'false',
                    eVar181: '@MEDIA_STREAM_TITLE@',
                    eVar182: '@MEDIA_STREAM_ID@',
                    eVar183: '@MEDIA_STREAM_ID@',
                    eVar184: eVar184 || '@MEDIA_STREAM_TYPE@',
                    eVar199: '@ADOBE_ID@',
                    prop25: '@MEDIA_STREAM_ID@',
                    prop26: '@MEDIA_PLAYER_VERSION@',
                    prop27: '@MEDIA_PLAYER_CONTEXT@',
                    prop28: '4.0',
                    prop29: 'Progressive Download',
                    prop30: '@MEDIA_STREAM_TITLE@',
                    prop32: '@MEDIA_INDEX_NAME@',
                    prop33: '@GAMEDAY_GAME_ID@',
                    prop34: '@GAMEDAY_GAME_PK@',
                    prop35: '@CURRENT_TIME_STAMP@',
                    prop43: '@MEDIA_TOPIC_NAME@',
                    prop49: '@MEDIA_EMBED_HOST@',
                    prop54: '@MEDIA_SYSTEM_AUTO_PLAY@'
                }
            ]
        }
    };
};

export { setPlayerConfig };
